import { render } from "./HandbookProcedureInfo.vue?vue&type=template&id=42365907"
import script from "./HandbookProcedureInfo.vue?vue&type=script&lang=js"
export * from "./HandbookProcedureInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__